import Vue from 'vue'
import router from './router'
Vue.prototype.go=function(path,options){
    router.push({path:path,query:{
		...options
	}})
}
Vue.prototype.toast=function(text){
    this.$createToast({
        txt: text,
        type: 'txt'
    }).show()
}
Vue.prototype.$isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}
Vue.component('v-header',() => import('./components/Header'))
Vue.component('v-footer',() => import('./components/Footer'))
Vue.filter('fixed',  (value)=> {
        return isNaN(value) ? '- -' : Number(value).toFixed(2)
})
Vue.filter('formatTime',  (v,t)=> {
    let date = new Date(v * 1000)
    if (date.toString() === 'Invalid Date') {
        return ''
    }
    let y = date.getFullYear()
    let M = date.getMonth() + 1
    let d = date.getDate()
    let h = date.getHours()
    let m = date.getMinutes()
    let padLeft = str => String(str).length < 2 ? `0${str}` : str
    return t ? `${y}-${padLeft(M)}-${padLeft(d)}  ${padLeft(h)}:${padLeft(m)}` : `${y}-${padLeft(M)}-${padLeft(d)}`
})
